import { observable } from 'mobx';
import { PaymentsList } from '@modules/payments/store/PaymentsList';

export class PaymentsStore {
    public static Name = 'paymentsStore' as const;

    @observable public paymentsList = new PaymentsList();
}

export const paymentsStore = new PaymentsStore();
